import { defineAsyncComponent } from 'vue';
import type { App, AsyncComponentLoader } from 'vue';
import type { ComponentExposed } from 'vue-component-type-helpers';
import _BasePageModal from './BasePageModal.vue';
import _EditableTable from './EditableTable.vue';
import _HeaderBtns from './HeaderBtns.vue';
import _SearchTable from './SearchTable.vue';

/** @deprecated 注册全局组件 */
export function useRenderComponents(app: App) {
  const components = import.meta.glob('./*.vue');
  app.use({
    /** 注册单文件组件 */
    install: function (app: App) {
      for (const [key, value] of Object.entries(components)) {
        const name = key.slice(key.lastIndexOf('/') + 1, key.lastIndexOf('.'));
        app.component(name, defineAsyncComponent(value as AsyncComponentLoader));
      }
    },
  });
}

export type SearchTableExposed = ComponentExposed<typeof _SearchTable>;
export const SearchTable = _SearchTable;

/** @deprecated */
export type EditableTableExposed = ComponentExposed<typeof _EditableTable>;
/** @deprecated */
export const EditableTable = _EditableTable;

export type BasePageModalExposed = ComponentExposed<typeof _BasePageModal>;
export const BasePageModal = _BasePageModal;
